module.exports = __webpack_public_path__ + "img/0da3d61.svg";